import { render, staticRenderFns } from "./ListDeleteDomain.vue?vue&type=template&id=60cffd5e"
import script from "./ListDeleteDomain.vue?vue&type=script&lang=js"
export * from "./ListDeleteDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports